// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3lEoS","header":"PatientQuestionnaire_header__21mJf","info":"PatientQuestionnaire_info__2qaAQ"};